export function pageView () {
  window.ga('send', 'pageview', {
    page: window.location.pathname
  })
}
